import {
  FETCH_CURRENT_USER,
  LOG_IN_USER,
  SET_EDITED_USER,
  SET_PASSWORD_CONFIGURING_USER,
  USER_LOGGING,
} from '../actions/types'

const initialState = {
  items: [],
  currentUser: null,
  passwordConfiguringUser: null,
  justEdited: null,
  isLogging: false,
  isFetching: true,
  authError: null,
  appConfig: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOGGING:
      return { ...state, isLogging: true, isFetching: true }

    case FETCH_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload.user,
        isFetching: false,
      }

    case SET_EDITED_USER:
      return {
        ...state,
        justEdited: action.payload,
      }

    case SET_PASSWORD_CONFIGURING_USER:
      return {
        ...state,
        passwordConfiguringUser: action.payload,
      }

    case LOG_IN_USER:
      return {
        ...state,
        currentUser: action.payload.user,
        authError: action.payload.error,
        isLogging: false,
      }

    default:
      return state
  }
}
